export const deliveryTypeOptions = [
  {
    displayName: 'None (data refresh only)',
    value: 'none',
    name: 'none',
    id: 'none',
    dataTest: 'none',
    enabled: true,
  },
  {
    displayName: 'Email',
    value: 'email',
    name: 'email',
    id: 'email',
    dataTest: 'email',
    enabled: true,
  },
  {
    displayName: 'Slack',
    value: 'slack',
    name: 'slack',
    id: 'slack',
    dataTest: 'slack',
    enabled: false,
  },
];
